const doc = [({"en":({"js":({"admin":({"reimbursements":({"time":({"my_reimbursements":"My reimbursements", "created_for_others":"Created for others"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;